export const CloseIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" id="icon-close" width="20" height="20" viewBox="0 0 20 20">
		<path id="Area" fill="none" d="M0 0H20V20H0z" />
		<path
			id="Border"
			fill="currentColor"
			d="M9.108 8L16 14.892 14.892 16 8 9.108 1.108 16 0 14.892 6.892 8 0 1.108 1.108 0 8 6.892 14.892 0 16 1.108z"
			transform="translate(2 2)"
		/>
	</svg>
)
